<template>
    <div class="pl-0 list-none flex flex-wrap gap-3">
        <span
            class="px-4 py-2 leading-none rounded-full"
            :class="classes"
            v-for="tag in tags"
            :key="tag.id"
        >{{ tag.name }}</span>
    </div>
</template>

<script>
export default {
    props: {
        theme: {
            type: String,
            default: 'system',
            validator: value => ['system', 'client-universe'].includes(value),
        },

        tags: {
            type: Array,
            required: true,
        },
    },
    
    computed: {
        classes() {
            return {
                'bg-brand-secondary text-brand-primary': this.theme === 'client-universe',
                'bg-secondary text-primary text-sm': this.theme === 'system',
            }
        }
    },
}
</script>
